import { TypeHelper } from "./TypeHelper";
import { format } from "date-fns-tz";

export class DateHelper {
    public static intlToUkDateString(intlDate: string) {
        const split = intlDate.split("-");
        return `${split[2].substr(0, 2)}/${split[1]}/${split[0]}`;
    }

    public static getFullDateNowString() {
        const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        const dateNow = new Date();
        return `${dateNow.getDate()} ${months[dateNow.getMonth()]} ${dateNow.getFullYear()}`;
    }

    public static getShortTextDate(date: any, includeTime?: boolean, includeSeconds?: boolean) {
        if (TypeHelper.isNullOrUndefined(date)) {
            return "";
        }

        const dateVal = DateHelper.getDateObjectFrom(date);
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const hours = dateVal.getHours();
        const minutes = dateVal.getMinutes();
        const seconds = dateVal.getSeconds();

        const dateString = `${dateVal.getDate()} ${months[dateVal.getMonth()]} ${dateVal.getFullYear()}`;
        const timeString = includeTime ? ` ${this.zeroPad(hours)}:${this.zeroPad(minutes)}` : "";
        const secondsString = includeSeconds ? `:${this.zeroPad(seconds)}` : "";

        return `${dateString}${timeString}${secondsString}`;
    }

    public static dateToIsoString(date?: Date, includeTime?: boolean) {
        return includeTime ? this.toDateObject(date)?.toISOString().slice(0, 16) : this.toDateObject(date)?.toISOString().slice(0, 10);
    }

    public static dateToInternationalString(date: Date) {
        const dd = date.getDate();
        const mm = date.getMonth() + 1; // January is 0!
        const yyyy = date.getFullYear();
        return `${yyyy}-${DateHelper.zeroPad(mm)}-${DateHelper.zeroPad(dd)}`;
    }

    public static dateNowInternational() {
        const dateToday = new Date();
        return DateHelper.dateToInternationalString(dateToday);
    }

    public static lessThan(d1: any, d2: any): boolean {
        return DateHelper.dateCompareDesc(d1, d2) === 1;
    }

    public static greaterThan(d1: any, d2: any): boolean {
        return DateHelper.dateCompareDesc(d1, d2) === -1;
    }

    public static dateCompareAsc(d1: any, d2: any): number {
        return DateHelper.dateCompareDesc(d1, d2) * -1;
    }

    public static dateCompareDesc(d1: any, d2: any): number {
        const dateA = DateHelper.getDateObjectFrom(d1);
        const dateB = DateHelper.getDateObjectFrom(d2);

        const timeA = dateA.getTime();
        const timeB = dateB.getTime();

        if (timeA === timeB) {
            return 0;
        }

        return timeA > timeB ? -1 : 1;
    }

    public static timeNow() {
        const now = new Date();
        return `${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}:${now.getMilliseconds()}`;
    }

    public static toDateObject(dateVal: any | undefined): Date | undefined {
        const val = dateVal ? DateHelper.getDateObjectFrom(dateVal) : undefined;
        return isNaN(val) ? undefined : val;
    }

    public static toDateObjectOrDefault(dateVal: any | undefined): Date {
        const val = dateVal ? DateHelper.getDateObjectFrom(dateVal) : undefined;
        return isNaN(val) ? new Date(0) : val;
    }

    public static endOfDay(dateVal: any | undefined): Date | undefined {
        const date = this.toDateObject(dateVal);
        if (date) {
            date.setHours(23, 59, 59, 999);
            return date;
        }

        return undefined;
    }

    public static startOfDay(dateVal: any | undefined): Date | undefined {
        const date = this.toDateObject(dateVal);
        if (date) {
            date.setHours(0, 0, 0, 0);
            return date;
        }

        return undefined;
    }

    public static isValidDateOrString(dateVal: any) {
        let isValid = !TypeHelper.isNullOrUndefined(dateVal);
        const dateObj = DateHelper.toDateObject(dateVal);
        isValid = isValid && !TypeHelper.isNullOrUndefined(dateObj);
        return isValid;
    }

    private static getDateObjectFrom(val: any): any {
        if (typeof val.getMonth === "function") {
            return val;
        }

        return new Date(val);
    }

    private static zeroPad(val: number): string {
        return val < 10 ? `0${val}` : `${val}`;
    }

    public static getDateInDDMMMYYYY(date: Date): string {
        const dd = String(date.getDate()).padStart(2, "0");
        const mm = String(date.getMonth() + 1).padStart(2, "0"); //January is 0!
        const yyyy = date.getFullYear();

        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        return dd + " " + months[date.getMonth()] + " " + yyyy;
    }

    private static addZero = (i: any) => {
        if (i < 10) {
            i = "0" + i;
        }
        return i;
    };

    public static getCurrentDateTime = () => {
        const today = new Date();
        return (
            today.getDate() +
            "/" +
            (today.getMonth() + 1) +
            "/" +
            today.getFullYear() +
            " - " +
            DateHelper.addZero(today.getHours()) +
            ":" +
            DateHelper.addZero(today.getMinutes())
        );
    };

    public static convertStringToDateAndFormat = (dateToConvert: string, formatter: string ="dd MMM yyyy"): string => {
        const formattedDate = format(new Date(dateToConvert), formatter);
        return formattedDate;
    };
    
}
